
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FormData } from "./types";

interface Country {
  code: string;
  name: string;
}

interface Props {
  countries: Country[];
  formData: FormData;
  onCountryChange: (value: string) => void;
}

const EditUserCountrySelect = ({ countries, formData, onCountryChange }: Props) => (
  <div className="grid gap-2">
    <Label htmlFor="country">Country</Label>
    <Select
      value={formData.country_code}
      onValueChange={onCountryChange}
    >
      <SelectTrigger>
        <SelectValue placeholder="Select a country" />
      </SelectTrigger>
      <SelectContent>
        {countries.map((country) => (
          <SelectItem key={country.code} value={country.code}>
            {country.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export default EditUserCountrySelect;
